export const isAgent = (nick: string) => {
  return nick.startsWith('agent:');
};

export const isTrigger = (nick: string) => {
  return nick.startsWith('agent:trigger');
};
